
import React, { Fragment } from 'react';

const datas = {
    weekDay: { 1: 'Mon', 2: 'Tue', 3: 'Wed', 4: 'Thu', 5: 'Fri', 6: 'Sat', 7: 'Sun' },
    dayOfTheWeek: { first: '1st', second: '2nd', third: '3rd', forth: '4th', fifth: '5th', sixth: '6th', seventh: '7th' },
};

export const Weekly = (props) => {
    const { FormControl, clsx, classes, changeEveryHandler,
        FormGroup, Checkbox, FormControlLabel, every, view } = props;


    return (
        <>
            <FormControl
                tabIndex={-1}
                className={clsx(classes.margin20t, classes.customRadioButton, classes.customRadioButtonMonthly)}
                variant={'standard'}
                fullWidth>
                <div className={classes.frequencyEveryPos}>
                    <div className={clsx(classes.frequencyEveryText, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Every</div>
                    <FormGroup aria-label="position" row>
                        {
                            Object?.entries(datas['weekDay'])?.map(([key, value]) => (
                                <FormControlLabel
                                    value={key}
                                    key={key}
                                    disabled={view}
                                    name={`every_${key}`}
                                    control={<Checkbox size={'small'} checked={every[`every_${key}`]}
                                        onChange={(e) => changeEveryHandler(e)}
                                    />}
                                    label={value}
                                    labelPlacement="end"
                                />
                            ))
                        }
                    </FormGroup>
                </div>
            </FormControl>
        </>
    )
}


export const WeeklyListView = (props) => {
    return (
        <div>
            {
                Object?.entries(datas['weekDay'])?.map(([key, value]) => (
                    <Fragment key={key}> {props?.data[`every_${key}`] ?
                        <span className={props.classes.everyDis}>{value}</span> : ''}</Fragment>
                ))
            }
        </div>
    )
}